// ----------------------------------------------------------------------------
// Component: Product Specs
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import 'init';

// Styles
import './_specs-table.scss';
